module.exports = __webpack_public_path__ + "img/uestc-logo.ee3bd884.png";